import { CustomObject } from './common'

export enum AdminAuditModule {
  CATALOGUE = 'CATALOGUE',
  INVENTORY = 'INVENTORY',
  PRICING = 'PRICING',
  ORDER = 'ORDER',
  FUNCTION_JOB = 'FUNCTION_JOB',
  CONFIGURATION = 'CONFIGURATION',
  USER = 'USER',
  STORE = 'STORE',
  AGGREGATOR = 'AGGREGATOR',
  FTP_CONFIGURATION = 'FTP_CONFIGURATION',
  AREA = 'AREA',
  PICKER_MAPPING = 'PICKER_MAPPING',
  FOC_ORDER = 'FOC_ORDER',
  CHAIN = 'CHAIN',
  FRESH_CATEGORY = 'FRESH_CATEGORY',
  FRESH_MANDATORY_BARCODE = 'FRESH_MANDATORY_BARCODE',
  FRESH_REPORT = 'FRESH_REPORT',
}

export enum AdminAuditAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',

  SYNC_PRICE = 'SYNC_PRICE',

  CHANGE_BARCODE = 'CHANGE_BARCODE',
  CHANGE_PRODUCT = 'CHANGE_PRODUCT',
  CHANGE_STORE = 'CHANGE_STORE',

  CALL_INVENTORY = 'CALL_INVENTORY',
  CALL_PRICING = 'CALL_PRICING',
  RUN_JOB = 'RUN_JOB',

  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
}

// ─────────────────────────────────────────────
// Sub-document interfaces
// ─────────────────────────────────────────────

export interface AuditUser {
  userId: string
  employeeId: string
  name: string
}

export interface AuditChangedField {
  field: string
  before: CustomObject
  after: CustomObject
}

// ─────────────────────────────────────────────
// Main document interface
// ─────────────────────────────────────────────

export interface IAdminAuditLog {
  /** Which feature area triggered this log */
  module: AdminAuditModule

  /** The type of operation that was performed */
  action: AdminAuditAction

  /** Primary key of the entity being acted on (optional for events like RUN_JOB) */
  entityId?: string

  /** Human-readable label for the entity (e.g. product name, order number) */
  entityLabel?: string

  /**
   * Field-level diff derived from before / after.
   * Only present when both snapshots are supplied.
   */
  changes: AuditChangedField[]

  /** Actor who performed the action */
  user?: AuditUser

  /**
   * Any additional context specific to the action
   * (e.g. job name for RUN_JOB, sync target for SYNC_PRICE).
   */
  metadata?: CustomObject

  createdAt: Date
}

// ─────────────────────────────────────────────
// Frontend query-param type
// ─────────────────────────────────────────────

export interface AdminAuditLogQueryParams {
  // Enum filters — exact match
  module?: AdminAuditModule
  action?: AdminAuditAction

  // Entity filters
  entityId?: string
  entityLabel?: string // partial match

  // User filters
  userId?: string // exact match → user.userId
  employeeId?: string // exact match → user.employeeId
  userName?: string // partial match → user.name

  // Date range on createdAt (ISO date strings: 'YYYY-MM-DD')
  startDate?: string
  endDate?: string

  // Pagination — excluded from filter, consumed by listInitOptions
  page?: string
  limit?: string
}
